export default [
  {
    header: 'Giriş Sayfası',
  },
  {
    title: 'Güncel Durum',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Hoş Geldiniz',
    route: '#',
    icon: 'FileTextIcon',
    resource: 'WELCOME',
    action: 'read',
  },
  {
    title: 'Slide Görseller',
    route: '#',
    icon: 'ImageIcon',
    resource: 'CAROUSEL',
    action: 'read',
  },
  {
    title: 'Duyurular',
    route: '#',
    icon: 'BellIcon',
    resource: 'NOTIFICATIONS',
    action: 'read',
  },
  {
    header: 'Menü Yönetimi',
  },
  {
    title: 'Ürünler',
    route: null,
    icon: 'CoffeeIcon',
    children: [
      {
        title: 'Oluştur',
        route: '#',
        resource: 'PRODUCT_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: '#',
        resource: 'PRODUCTS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Kategoriler',
    route: null,
    icon: 'FolderIcon',
    children: [
      {
        title: 'Oluştur',
        route: '#',
        resource: 'PRODUCT_CATEGORY_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: '#',
        resource: 'PRODUCT_CATEGORIES',
        action: 'read',
      },
    ],
  },
  {
    header: 'Restoran Yönetimi',
  },
  {
    title: 'Sosyal Medya Hesapları',
    route: '#',
    icon: 'Share2Icon',
    resource: 'SOCIALMEDIA',
    action: 'read',
  },
  {
    title: 'QR Kod Yönetimi',
    route: '#',
    icon: 'GridIcon',
    resource: 'SOCIALMEDIA',
    action: 'read',
  },
  {
    title: 'Genel Yapılandırma',
    route: '#',
    icon: 'SettingsIcon',
    resource: 'CONFIGS',
    action: 'read',
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'ADMIN_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'all',
        action: 'manage',
      },
    ],
  },
]
